import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { LocalService, ManagerService } from '../../../core';

@Component({
  selector: 'app-dashboard-seller-filter',
  templateUrl: './dashboard-seller-filter.component.html',
  styleUrls: ['./dashboard-seller-filter.component.scss']
})
export class DashboardSellerFilterComponent implements OnInit {

  @Output() selectionChange = new EventEmitter<number[]>();

  sellers: { id: number; fullName: string }[] = [];
  selectedSellers: { id: number; fullName: string }[] = [];

  private userData: any;

  constructor(private managerService: ManagerService) {}

  ngOnInit() {
    this.userData = LocalService.get('userProfile');
    this.loadSellers();
  }

  private loadSellers() {
    this.managerService.getUsersUnderManager(this.userData.id).subscribe((data: any) => {
      if (data) {
        this.sellers = data.reduce((acc: any[], item: any) => {
          if (!acc.find((u: any) => u.id === item.id)) {
            acc.push({ id: item.id, fullName: `${item.firstName} ${item.lastName}` });
          }
          return acc;
        }, []).sort((a: any, b: any) => a.fullName.localeCompare(b.fullName));
      }
    });
  }

  get aggregationLabel(): string {
    const total = this.sellers.length;
    const selected = this.selectedSellers.length;
    if (selected === 0 || selected === total) {
      return `Aggregated across all ${total} sellers in your company`;
    }
    return `Aggregated across ${selected} of ${total} sellers in your company`;
  }

  onMultiSelectionChange(selected: any[]) {
    this.selectedSellers = selected;
    this.selectionChange.emit(
      selected.length > 0 ? selected.map(s => s.id) : []
    );
  }
}
